import { RouteProp, useRoute } from "@react-navigation/native";
import { useAtomValue } from "jotai";
import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { currentProfileAtom } from "../../../features/Club/atoms";
import { useFlags } from "../../../utils/launchDarkly";
import { useEventPatronTypeRedirect } from "../hooks/useEventPatronTypeRedirect";
import {
  EventDetailShell,
  EventDetailQueryString,
} from "./EventDetailShell/EventDetailShell";
import {
  EventDetailShellQuery,
  EventDetailShellQuery$variables,
} from "./EventDetailShell/__generated__/EventDetailShellQuery.graphql";
import { EventDetailStackNavigatorParamList } from "./EventDetailStackNavigator";
import { EventDetailWrapper } from "./EventDetailWrapper/EventDetailWrapper";

export const EventDetailHome = () => {
  return (
    <Box flex={1} bg="surface-primary">
      <Suspense fallback={<Loader />}>
        <EventDetailHomeInner />
      </Suspense>
    </Box>
  );
};

const EventDetailHomeInner = () => {
  const currentProfile = useAtomValue(currentProfileAtom);
  const memberId = currentProfile?.memberId;
  const { newPatronEventBookingFlow } = useFlags();
  const route =
    useRoute<
      RouteProp<EventDetailStackNavigatorParamList, "EventDetailHome">
    >();

  const { eventID } = route.params;

  const [queryRef, loadQuery] = useQueryLoader<EventDetailShellQuery>(
    EventDetailQueryString
  );

  const canViewEvent = useEventPatronTypeRedirect({
    eventId: eventID,
  });

  useEffect(() => {
    const queryParams: EventDetailShellQuery$variables = {
      eventID,
    };

    if (memberId) {
      queryParams.memberId = memberId;
    }

    if (eventID) {
      loadQuery(queryParams, {
        fetchPolicy: "store-and-network",
      });
    }
  }, [loadQuery, memberId, eventID]);

  if (!canViewEvent) {
    return <Loader />;
  }

  return (
    <Suspense fallback={<Loader />}>
      {queryRef ? (
        newPatronEventBookingFlow ? (
          <EventDetailWrapper queryRef={queryRef} />
        ) : (
          <EventDetailShell queryRef={queryRef} />
        )
      ) : null}
    </Suspense>
  );
};
